import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({selector:'app-qr-self-checkin-group', templateUrl:'./qr-self-checkin-group.component.html', standalone:false})
export class QrSelfCheckinGroupComponent {
  constructor(private route: ActivatedRoute) {}
  get targetId(): number { return Number(this.route.snapshot.params.groupId); }
}
